import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import type { ReactNode } from 'react';

interface AiMessageProps {
  message?: string;
}

const AiMessage = ({ message }: AiMessageProps) => {
  return (
    <div id="ai-wrapper" className="mb-0 fs--1 p-1 text-break">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          a: ({ href, children }: { href?: string; children?: ReactNode }) => (
            <Link to={href ?? ''}>{children}</Link>
          )
        }}
      >
        {message}
      </ReactMarkdown>
    </div>
  );
};

export default AiMessage;
